<div ngbDropdown [placement]="'bottom-right'" class="kt-header__topbar-item kt-header__topbar-item--user"
  #myDrop="ngbDropdown">
  <div ngbDropdownToggle class="kt-header__topbar-wrapper">
    <div class="kt-header__topbar-user" id="location-box" (keydown.enter)="getAllLocation()" (click)="getAllLocation()">
      <span class="kt-header__topbar-icon">
        <i><img src="../../../../../../assets/media/icons/location-header.png" alt="location-header"
            style="height: 20px;" /></i>

      </span>
      <a class="kt-header__topbar-username kt-hidden-mobile">
        {{currentLocation}}
      </a>
      <!-- <ng-template #defaultLocation>
        <span class="kt-header__topbar-username kt-hidden-mobile">
          Location
        </span>
      </ng-template> -->
    </div>
  </div>
  <!-- <div ngbDropdownMenu aria-labelledby="dropdownBasic1" ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
    <div [perfectScrollbar]="{wheelPropagation: false}" [ngStyle]="{'max-height': '40vh', 'position': 'relative'}"
      class="kt-notification kt-margin-t-10 kt-margin-b-10">
    <ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
      <ng-container *ngFor="let location of locationList">
        <li class="kt-nav__item" [ngClass]="{'kt-nav__item--active': active}">
          <a href="javascript:;" (click)="setLocation(location.Name);myDrop.close();" [ngClass]="{'kt-nav__link--active': active}"
            class="kt-nav__link">
            <span class="kt-nav__link-text">{{location.Name}}</span>
          </a>
        </li>
      </ng-container>
    </ul>
    </div>
  </div> -->


  <div ngbDropdownMenu aria-labelledby="dropdownBasic1"
    class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">

    <!-- Search input field -->
    <div class="px-3 py-2">
      <input type="text" placeholder="Search location..." [(ngModel)]="searchTerm" (input)="filterLocations()"
        class="form-control">
    </div>

    <cdk-virtual-scroll-viewport itemSize="5" class="kt-notification kt-margin-t-10 kt-margin-b-10">
      <ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
        <ng-container *ngIf="filteredLocationList?.length > 0; else noRecords">
          <li *ngFor="let location of filteredLocationList" class="kt-nav__item"
            [ngClass]="{'kt-nav__item--active': currentLocation === location.Name}">
            <a href="javascript:;" (click)="setLocation(location.Name, true); myDrop.close();" class="kt-nav__link">
              <span class="kt-nav__link-text">{{ location.Name }}</span>
            </a>
          </li>
        </ng-container>
        <ng-template #noRecords>
          <li class="kt-nav__item kt-nav__item--disabled text-center">
            <span class="kt-nav__link-text text-muted">
              {{'common.No records available.' | translate}}
            </span>
          </li>
        </ng-template>
      </ul>
    </cdk-virtual-scroll-viewport>
  </div>

</div>